import { Button, Divider, Stack, Typography, useMediaQuery } from "@mui/material";
import CopyrightIcon from '@mui/icons-material/Copyright';
export const termsOfUseUrl = 'https://app.termly.io/policy-viewer/policy.html?policyUUID=7ee5cba1-685d-4520-93cf-ac887ce34227'
export const privacyPolicyUrl = 'https://app.termly.io/policy-viewer/policy.html?policyUUID=648a7ee0-8ad3-4472-bb38-c1a6660f871f'

const LegalBar = () => {
    const isMobile = useMediaQuery('(max-width:800px)')

    return (
            <Stack
                position='fixed'
                alignItems='center'
                direction='row'
                justifyContent='center'
                spacing={1}
                divider={<Divider orientation="vertical" flexItem />}
                useFlexGap
                sx={{ flexWrap: 'wrap', bottom: isMobile ? 100 : 20 }}
            >
                <Button
                    color= 'secondary'
                    onClick={() => window.open(privacyPolicyUrl, '_blank')}
                    sx={{ fontSize: '0.6rem', opacity: 0.5}}
                >
                    Privacy Policy
                </Button>
                <Button
                    color= 'secondary'
                    onClick={() => window.open(termsOfUseUrl, '_blank')}
                    sx={{ fontSize: '0.6rem', opacity: 0.5}}
                >
                    Terms of Use
                </Button>
                <Stack alignItems='center'>
                <Typography sx={{ fontFamily: 'LemonMilk', display: 'flex', alignItems: 'center', fontSize: '0.6rem', opacity: 0.5 }}>
                    <CopyrightIcon fontSize="inherit" sx={{ mr: 0.5 }} />
                        2024 Abstract the Artist LLC
                    </Typography>
                    <Typography sx={{ fontFamily: 'LemonMilk', display: 'flex', alignItems: 'center', fontSize: '0.6rem', opacity: 0.5 }}>
                        All rights reserved
                    </Typography>
                </Stack>
                <Stack alignItems='center'>
                <Typography sx={{ fontFamily: 'LemonMilk', display: 'flex', alignItems: 'center', fontSize: '0.6rem', opacity: 0.5 }}>
                <CopyrightIcon fontSize="inherit" sx={{ mr: 0.5 }} />

                        2024 Dainger Zone LLC
                    </Typography>
                    <Typography sx={{ fontFamily: 'LemonMilk', display: 'flex', alignItems: 'center', fontSize: '0.6rem', opacity: 0.5 }}>
                        All rights reserved
                    </Typography>
                </Stack>
            </Stack>
    )
}

export default LegalBar;